import axios from "axios";

const API_URL = "https://srinivasafleet.com/api";

function getAuthHeaders() {
  const token = localStorage.getItem("token");

  return {
    Authorization: `Bearer ${token}`,
  };
}

export const getOutstandingSuppliers = async (
  serviceLocationId = null
) => {
  try {
    const config = {
      headers: getAuthHeaders(),
      params: {},
    };

    if (serviceLocationId) {
      config.params.service_location_id = serviceLocationId;
    }

    const response = await axios.get(
      `${API_URL}/outstanding-suppliers/`,
      config
    );

    return response.data;
  } catch (error) {
    console.error("Outstanding API Error:", error);

    throw new Error(
      error.response?.data?.detail ||
      "Failed to fetch outstanding suppliers."
    );
  }
};

export const updateOutstandingAmount = async (
  outstandingId,
  outstandingAmount,
  serviceLocationId = null
) => {
  try {
    const config = {
      headers: getAuthHeaders(),
      params: {},
    };

    if (serviceLocationId) {
      config.params.service_location_id = serviceLocationId;
    }

    const response = await axios.put(
      `${API_URL}/outstanding-suppliers/${outstandingId}`,
      { outstanding_amount: outstandingAmount },
      config
    );

    return response.data;
  } catch (error) {
    console.error("Outstanding Update API Error:", error);

    throw new Error(
      error.response?.data?.detail ||
      "Failed to update outstanding amount."
    );
  }
};